import { Box, Paper, Typography, useTheme } from "@mui/material";

import { formatDecimal } from "@aclymatepackages/formatters";

import ScoutEmissionsChart from "../../scout/cards/ScoutEmissionsChart";

const HotspotBar = ({ label, share }) => {
  const { palette } = useTheme();
  const width = Math.max(0, Math.min(100, Math.round(share || 0)));
  return (
    <Box mb={1.5}>
      <Box display="flex" justifyContent="space-between" mb={0.5} gap={1}>
        <Typography variant="body2" color="textPrimary" noWrap>
          {label}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {`${formatDecimal(share || 0)}%`}
        </Typography>
      </Box>
      <Box
        sx={{
          height: 8,
          borderRadius: "4px",
          backgroundColor: palette.backgroundGray.main
        }}
      >
        <Box
          sx={{
            height: 8,
            borderRadius: "4px",
            width: `${width}%`,
            backgroundColor: palette.secondary.main
          }}
        />
      </Box>
    </Box>
  );
};

const ExplorerOverview = ({ surveyEmissions, hotspots }) => (
  <Box>
    <Box mb={1}>
      <Typography variant="subtitle1" color="textPrimary">
        Explorer overview
      </Typography>
    </Box>
    <Box
      display="flex"
      gap={2}
      alignItems="stretch"
      sx={{ flexDirection: { xs: "column", md: "row" } }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          "& > .MuiPaper-root": { maxWidth: "none", width: "100%" }
        }}
      >
        <ScoutEmissionsChart
          title="Emissions by scope"
          emissions={surveyEmissions}
          viewMode="scopes"
        />
      </Box>
      <Paper
        elevation={1}
        sx={{ p: 2, borderRadius: "8px", flex: 1, minWidth: 0 }}
      >
        <Typography variant="subtitle1" color="textPrimary">
          Top emission hotspots
        </Typography>
        <Box mt={1.5}>
          {(hotspots || []).length === 0 && (
            <Typography variant="body2" color="textSecondary">
              No hotspots yet — complete your estimate to see them.
            </Typography>
          )}
          {(hotspots || []).map((hotspot) => (
            <HotspotBar
              key={hotspot.categoryKey || hotspot.label}
              label={hotspot.label}
              share={hotspot.share}
            />
          ))}
        </Box>
      </Paper>
    </Box>
  </Box>
);

export default ExplorerOverview;
